<template>
    <div>
        <header
            class="flex justify-between items-start px-3 pb-4 pt-7 lg:p-12 fixed top-0 lef-0 w-full z-[35] pointer-events-none"
            :class="[{'bg-white-gradient': variant === 'black'}, {'bg-black-gradient': variant === 'white'}]"
        >
            <RouterLink to="/" class="pointer-events-auto">
                <TransitionFade>
                    <AtomFluxLogo v-if="!isScolled" :color="variant"/>
                </TransitionFade>
            </RouterLink>

            <div class="flex items-center gap-5 pointer-events-auto -mt-[10px]">
                <router-link :to="{ name: 'search-preview' }" class="-mr-[13px]">
                    <AtomIcSearch :color="variant"/>
                </router-link>
                <router-link :to="{ name: 'anarchive' }">
                    <AtomIcFlux :color="variant"/>
                </router-link>
                <div @click="openMenu">
                    <AtomIcMenu :color="variant"/>
                </div>
            </div>
        </header>
        <div>
            <OrganismMenu v-show="isMenuOpen"></OrganismMenu>
        </div>

        <main>
            <slot/>
        </main>

        <OrganismFooter v-if="!withoutFooter"></OrganismFooter>
    </div>
</template>

<script>

import AtomFluxLogo from "../components/global/atoms/AtomFluxLogo.vue";
import AtomIcMenu from "../components/layout/atoms/AtomIcMenu.vue";
import AtomIcSearch from "../components/layout/atoms/AtomIcSearch.vue";
import AtomIcFlux from "../components/layout/atoms/AtomIcFlux.vue";
import TransitionFade from "../transitions/TransitionFade.vue";
import OrganismFooter from "../components/global/organisms/OrganismFooter.vue";
import {mapMutations, mapState} from "vuex";
import OrganismMenu from "../components/global/organisms/OrganismMenu.vue";

export default {
    name: 'LayoutDefault',
    components: {OrganismMenu, OrganismFooter, TransitionFade, AtomFluxLogo, AtomIcMenu, AtomIcSearch, AtomIcFlux},
    props: {
        variant: {
            type: 'white' | 'black',
            required: true,
        },
        withoutFooter: {
            type: Boolean,
        },
        hideLogoOnScroll: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data () {
        return{
            isScolled: false
        }
    },
    methods: {
        ...mapMutations('menu', [
            'openMenu',
        ]),

        handleScroll(){
            this.isScolled = window.scrollY > 100 && this.hideLogoOnScroll;
        }
    },
    computed: {
        ...mapState('menu', [
            'isMenuOpen'
        ]),
    },
    created () {
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy () {
        window.removeEventListener('scroll', this.handleScroll);
    },
}
</script>

<style lang="scss" scoped>
.bg-white-gradient {
    background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
}
.bg-black-gradient {
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.3) 20%, rgba(0, 0, 0, 0) 100%);
}
</style>
